import { render, staticRenderFns } from "./UiAddToList.vue?vue&type=template&id=2f5eaf80&"
import script from "./UiAddToList.vue?vue&type=script&lang=js&"
export * from "./UiAddToList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports